import styled from "@emotion/styled"

// Prediction horizon color palette
export const TOOLTIP_COLORS = {
  // T+1 horizon
  BASELINE_1P: "#90caf9",   // Blue
  ADJUSTED_1P: "#a5d6a7",   // Green
  // T+3 horizon
  BASELINE_3P: "#ffb74d",   // Orange
  ADJUSTED_3P: "#ce93d8",   // Purple
  // T+9 horizon
  BASELINE_9P: "#ef9a9a",   // Red
  ADJUSTED_9P: "#80cbc4",   // Teal
  // Base colors
  TEXT_PRIMARY: "#e0e0e0",
  TEXT_SECONDARY: "#bbb",
  TEXT_HEADER: "#fff",
  BACKGROUND: "#1e1e1e",
  BORDER: "#444",
  BORDER_LIGHT: "#333",
  BORDER_HEADER: "#555",
} as const

interface TooltipContainerProps {
  minWidth?: number
}

export const TooltipContainer = styled.div<TooltipContainerProps>(({ minWidth = 480 }) => ({
  padding: 10,
  minWidth,
  backgroundColor: TOOLTIP_COLORS.BACKGROUND,
  color: TOOLTIP_COLORS.TEXT_PRIMARY,
  border: `1px solid ${TOOLTIP_COLORS.BORDER}`,
  borderRadius: 4,
  boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
}))

export const TooltipTable = styled.table({
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 12,
})

interface TooltipCellProps {
  color?: string
  align?: "left" | "right"
}

export const TooltipTh = styled.th<TooltipCellProps>(
  ({ color = TOOLTIP_COLORS.TEXT_HEADER, align = "left" }) => ({
    padding: "6px 10px",
    borderBottom: `2px solid ${TOOLTIP_COLORS.BORDER_HEADER}`,
    textAlign: align,
    fontWeight: "bold",
    color,
    whiteSpace: "nowrap",
  }),
)

export const TooltipTd = styled.td<TooltipCellProps>(
  ({ color = TOOLTIP_COLORS.TEXT_SECONDARY, align = "left" }) => ({
    padding: "5px 10px",
    borderBottom: `1px solid ${TOOLTIP_COLORS.BORDER_LIGHT}`,
    textAlign: align,
    color,
    whiteSpace: "nowrap",
  }),
)

export const TooltipPeriodSection = styled.div({
  marginTop: 10,
  paddingTop: 8,
  borderTop: `1px solid ${TOOLTIP_COLORS.TEXT_PRIMARY}`,
  fontSize: 12,
  lineHeight: 1.4,
})

interface PeriodLineProps {
  color: string
}

export const PeriodLine = styled.div<PeriodLineProps>(({ color }) => ({
  color,
}))
